/**
 * App root — routing + auth wrapper.
 */
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './components/Auth/AuthContext'
import { PortfolioDataProvider } from './hooks/PortfolioDataContext'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import LoginPage from './components/Auth/LoginPage'
import SignupPage from './components/Auth/SignupPage'
import MfaEnroll from './components/Auth/MfaEnroll'
import MfaVerify from './components/Auth/MfaVerify'
import AppShell from './components/Layout/AppShell'
import Dashboard from './components/Dashboard'
import DataImport from './components/Portfolio/DataImport'
import FundVariables from './components/Portfolio/FundVariables'
import DocumentCoverage from './components/Portfolio/DocumentCoverage'
import LookupAdmin from './components/Admin/LookupAdmin'
import CashRequirements from './components/CashRequirements'

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PortfolioDataProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />

          {/* MFA routes — require authentication but not MFA completion */}
          <Route path="/mfa/enroll" element={<MfaEnroll />} />
          <Route path="/mfa/verify" element={<MfaVerify />} />

          {/* Protected routes — require auth + MFA */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <AppShell><Dashboard /></AppShell>
            </ProtectedRoute>
          } />
          <Route path="/import" element={
            <ProtectedRoute>
              <AppShell><DataImport /></AppShell>
            </ProtectedRoute>
          } />
          <Route path="/fund-variables" element={
            <ProtectedRoute>
              <AppShell><FundVariables /></AppShell>
            </ProtectedRoute>
          } />
          <Route path="/document-coverage" element={
            <ProtectedRoute>
              <AppShell><DocumentCoverage /></AppShell>
            </ProtectedRoute>
          } />
          <Route path="/cash-requirements" element={
            <ProtectedRoute>
              <AppShell><CashRequirements /></AppShell>
            </ProtectedRoute>
          } />
          <Route path="/admin/classifications" element={
            <ProtectedRoute>
              <AppShell><LookupAdmin /></AppShell>
            </ProtectedRoute>
          } />

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        </PortfolioDataProvider>
      </AuthProvider>
    </BrowserRouter>
  )
}
